import React from "react";
import { chatApi, useGetNursingHomeLocationsQuery } from "../../services/chatService";
import { AsyncSelectField } from "./asyncSelectField";

export const AsyncProviderSearchField = ({ control, name, rules, title, providerType, errors, defaultValue, onChange, isDisabled, isMulti}) => {
    
    const [getAllProvider] = chatApi.endpoints.getAllProvider.useLazyQuery();
    const [getProvidersIncludingExternal] = chatApi.endpoints.getProvidersIncludingExternal.useLazyQuery();
    const [getExternalProviders] = chatApi.endpoints.getExternalProviders.useLazyQuery();
    const [getProvider] = chatApi.endpoints.getProvider.useLazyQuery();
    const {data: nursingHomeLocations } = useGetNursingHomeLocationsQuery({skip: providerType !== 'nurse_provider' });

    
    const search =  async (query) => {
        if (query?.length > 2) {
            let response;
            if(providerType === 'external'){
                response = await getExternalProviders({ keyword: query })
            }
            else if(providerType === 'primary'){
                response = await getProvidersIncludingExternal({ keyword: query })
            }
            else if(providerType === 'nurse_provider'){
                response = await getProvider({location_id: nursingHomeLocations.map((loc) => loc.id).join(','), keyword: query});
            }
            else{  
                response = await getAllProvider({ keyword: query })
            }
            
            return response?.data.map((provider) => {
                if(provider.User){
                    return {...provider.User, label: provider.User?.name}
                }
                else{
                    return {...provider, label: provider?.name || provider?.user_name}
                }
            })
        }
    }

    return (<>
        <AsyncSelectField
            defaultValue={defaultValue}
            search={search}
            title={title}
            name={name}
            control={control}
            rules={rules}
            errors={errors}
            onChange={
                onChange ? onChange : null
            }
            isDisabled = {isDisabled}
            isMulti={isMulti}
        />
    </>)
}